webpackJsonp([281],{

/***/ 1074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.5.2 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1889:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1074),
  /* template */
  __webpack_require__(2150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.5.2-115.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.5.2-115.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37c1d3d2", Component.options)
  } else {
    hotAPI.reload("data-v-37c1d3d2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2150:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.5.2 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] emit event `input` before `on-change`")]), _vm._v(" "), _c('li', [_vm._v("[feature] add attribute `inlineDesc` to `options`")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/inline-x-number.html"
    }
  }, [_vm._v("InlineXNumber")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] now inline-x-number is available")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/panel.html"
    }
  }, [_vm._v("Panel")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add type(4,5) and info meta(source,date,other)")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-header.html"
    }
  }, [_vm._v("PopupHeader")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new component")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:popup-style #1656")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:popup-style #1656")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-address.html"
    }
  }, [_vm._v("XAddress")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:popup-style #1656")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-37c1d3d2", module.exports)
  }
}

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1889);

/***/ })

});


// WEBPACK FOOTER //
// 281.7ee88a87.js